(() => {
  const root = document.documentElement;
  const main = document.querySelector('main');
  if (!main || root.classList.contains('shopify-design-mode') || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const selector = '.shopify-section, main product-card, main .collection-card';
  const seen = new WeakSet();
  root.classList.add('vm-reveal-ready');
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vm-revealed');
        observer.unobserve(entry.target);
      }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
  const reveal = (scope) => {
    const nodes = [];
    if (scope instanceof Element && scope.matches(selector)) nodes.push(scope);
    if (scope.querySelectorAll) nodes.push(...scope.querySelectorAll(selector));
    for (const node of nodes) {
      if (seen.has(node) || node.closest('#shopify-section-header, #shopify-section-footer')) continue;
      seen.add(node);
      if (node.matches('product-card, .collection-card')) {
        const siblings = [...node.parentElement.children].filter((item) => item.matches('product-card, .collection-card'));
        node.style.setProperty('--vm-reveal-delay', (Math.min(siblings.indexOf(node), 7) * 65) + 'ms');
      }
      node.setAttribute('data-vm-reveal', '');
      observer.observe(node);
    }
  };
  reveal(main);
  const mutationObserver = new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) if (node instanceof Element) reveal(node);
  });
  mutationObserver.observe(main, { childList: true, subtree: true });
})();